import { useLocation } from 'react-router-dom';
import { useLayout } from '../LayoutContext';

interface IntroProps {
    setScreen: (screen: 'intro' | 'recorder' | 'uploader' | 'webcam' | 'form') => void;
}

const isValidHexColor = (color: string): boolean => {
    return /^#([0-9A-F]{3}){1,2}$/i.test(color);
};

const Intro: React.FC<IntroProps> = ({ setScreen }) => {
    const { layout } = useLayout();
    const location = useLocation();

    const safeColors = {
        buttons: isValidHexColor(layout.color.buttons) ? layout.color.buttons : '#22FFAF',
        text: isValidHexColor(layout.color.text) ? layout.color.text : '#000000',
        hover: isValidHexColor(layout.color.hover) ? layout.color.hover : '#1DE9A3',
    };

    const isDeepfake = location.pathname.includes("/deepfake");
    const isAudio = location.pathname.includes("/audio");
    const isVideo = location.pathname.includes("/video");

    const title = isDeepfake
        ? "Deepfake Generator"
        : isAudio
            ? "Voice Sampler"
            : isVideo
                ? "Video Sampler"
                : "";

    const description = isDeepfake
        ? "Record a voice sample, then capture a photo to generate a deepfake video"
        : "Record a sample with the help of our assistant";

    return (
        <div style={{ fontFamily: "'Nunito Sans', sans-serif" }}
            className="w-full max-w-[440px] p-8 rounded-xl bg-black shadow-[0_4px_20px_rgba(0,0,0,0.5)] flex flex-col items-center">
            <h2 className="text-[26px] font-extrabold mb-2" style={{ color: safeColors.buttons, fontStyle: 'normal' }}>
                {title}
            </h2>
            <div className="text-gray-400 mb-8 text-center text-sm leading-relaxed">
                {description}
            </div>
            <div className="flex justify-center">
                <button
                    className="border-none rounded-lg px-6 py-3 font-bold flex items-center gap-3 text-base cursor-pointer"
                    style={{
                        backgroundColor: safeColors.buttons,
                        color: safeColors.text,
                        transition: 'background 0.15s',
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = safeColors.hover)}
                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = safeColors.buttons)}
                    onClick={() => setScreen('recorder')}
                >
                    {(isAudio || isDeepfake) && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"
                            stroke={safeColors.text} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M10 1.5a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0v-6a3 3 0 0 0-3-3Z" />
                            <path d="M16 8.5v1a6 6 0 0 1-12 0v-1" />
                            <line x1="10" x2="10" y1="15.5" y2="18.5" />
                        </svg>
                    )}
                    {isVideo && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke={safeColors.text} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z" />
                            <path d="m6.2 5.3 3.1 3.9" /><path d="m12.4 3.4 3.1 4" />
                            <path d="M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
                        </svg>
                    )}
                    Record
                </button>
            </div>
        </div>
    );
};

export default Intro;
